import { Component, OnInit, Input, HostListener, ViewChild } from '@angular/core';
import { FormArray, ReactiveFormsModule, FormsModule, Validators } from '@angular/forms';
import { ApprovalsService, DataService, UserService, OperationsService } from '../../_services/index';
import { AuthenticationService, StorageService, AnalyticsService } from '../../_services/index';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {Color} from 'ng2-charts';

@Component({
  selector: 'app-ageing',
  templateUrl: './ageing.component.html',
  styleUrls: ['./ageing.component.css']
})
export class AgeingComponent implements OnInit {
  @Input('currentUser') currentUser:any;
  ageing_analysis:any;
  loading = false;
  constructor(public analytics: AnalyticsService, public approvalService: ApprovalsService, public dataService: DataService,
    public router: Router, public fb: FormBuilder, public operationsService: OperationsService, public authService: AuthenticationService,
    public storageService: StorageService, public route: ActivatedRoute) {
    this.currentUser = this.storageService.read<any>('currentUser');

  }

  ngOnInit() {
    if(this.currentUser){
      this.reunAgeingAnalysis();
    }
  }
  reunAgeingAnalysis() {
    this.loading = true;
    this.analytics.reunAgeingAnalysis(this.currentUser.token)
      .subscribe(data => {
        // //console.log(data);
        this.loading = false;
        this.ageing_analysis = data.data; 
      });
  }

}
